/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

export const FEIDE_ID_TOKEN_COOKIE = "feide_id_token";
export const FEIDE_STATE_COOKIE = "ndla_auth_state";
export const FEIDE_NONCE_COOKIE = "ndla_nonce";
export const FEIDE_PKCE_CODE_COOKIE = "ndla_PKCE_code";
export const FEIDE_RETURN_TO_COOKIE = "ndla_return_to";
